import {api} from "./api";
import {MODERATOR_COUNT, VICTIM_STATISTICS} from "../mock/URLs";
import {ChartPeriods, GetDashboardChartStatsResponse} from "../types/stats";


type GetStats = {
  user_count: number,
  lesson_count: number,
  question_count: number,
  news_count: number,
  help_count: number,
  victim_count: number,
  test_count: number,
  resource_count: number,
  student_count: number
}

export const getAllStats = async () => {
  try {
    const {data} = await api.get<GetStats>(MODERATOR_COUNT)
    return data
  } catch (e) {
    throw e
  }
}

type GetChartStatsProps = {
  params: {
    distance: ChartPeriods
    type: "victim" | "user"
  }
}
export const getDashboardChartStats = async ({params}:GetChartStatsProps) => {
  try {
    const {data} = await api.get<GetDashboardChartStatsResponse>(VICTIM_STATISTICS, {
      params
    })
    return data.data
  } catch (e) {
    throw e
  }
}